<div *transloco="let t">
    <mat-expansion-panel [expanded]="true">
        <mat-list dense class="site-list">
            @if (showTitle) {
            <mat-panel-title class="mat-expansion-title">
                <span>{{ t("provider.preferred-locations") }}</span>
            </mat-panel-title>
            } @for (site of sites; track site) {
            <mat-list-item>
                <div fxLayout="row" fxLayoutAlign="space-between">
                    <mat-checkbox
                        color="primary"
                        [value]="site.siteId.toString()"
                        [checked]="selectedSiteIds.includes(site.siteId)"
                        (change)="selectSite($event)"
                        [name]="site.streetAddress"
                    >
                        <span>
                            {{ site.streetAddress }}<br />
                            {{ site.city }}, {{ site.stateCode }}
                            {{ site.postalCode }}&nbsp;
                        </span>
                    </mat-checkbox>
                </div>
            </mat-list-item>
            }
        </mat-list>
    </mat-expansion-panel>
</div>
